module.exports = __webpack_public_path__ + "static/media/negative-balance-ratio.76753649.svg";